import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BackOffServiceService } from './services/back-off-service.service';
import { Routes, RouterModule } from '@angular/router';
import { RegisterComponent } from './register-component/register-component.component';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private cookie: CookieService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.cookie.get('sessionToken')) {
      console.log('true authentication guard');
      return true;
    } else {
      console.log('false authentication guard');
      this.router.navigateByUrl('/Login');
      return false;
    }
  }
}
